import React from 'react';
import styled from 'styled-components';
import {Typography} from 'epic-ue-ui';
import {HomeSectionProps} from './Section';

const HomeSectionHeaderWrapper = styled.div`
    width: 100%;
    height: 73px;
    position: relative;
    display: flex;
    align-items: center;
    border-radius: 8px;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));

    &:after {
        z-index: 1;
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 40%;
        height: 100%;
        border-radius: 6px;
        background: linear-gradient(90deg, rgba(23, 22, 34, 0.8) 32.92%, rgba(0, 0, 0, 0) 100%);
    }

    ${p => p.theme.breakpoints.up('sm')} {
        height: 99px;
    }
    ${p => p.theme.breakpoints.up('xl')} {
        height: 140px;
    }

    .section-header-bg-image {
        z-index: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        position: absolute;
        border-radius: 8px;
    }

    .title {
        z-index: 2;
        font-family: Inter;
        font-size: 20px;
        line-height: 25px;
        letter-spacing: -0.2px;
        margin-left: 24px;

        ${p => p.theme.breakpoints.up('sm')} {
            font-size: 30px;
            line-height: 35px;
            letter-spacing: -0.3px;
            margin-left: 32px;
        }
        ${p => p.theme.breakpoints.up('xl')} {
            font-size: 40px;
            line-height: 45px;
            letter-spacing: -0.5px;
            margin-left: 60px;
        }
    }
`;

export const HomeSectionHeader: React.FC<Pick<HomeSectionProps, 'title' | 'background' | 'backgroundAlt'>> = ({title, background, backgroundAlt}) => (
    <HomeSectionHeaderWrapper>
        <img alt={backgroundAlt} className="section-header-bg-image" src={background} loading="lazy" />
        <Typography variant="h2" className="title">
            {title}
        </Typography>
    </HomeSectionHeaderWrapper>
);
